import { Link } from "react-router-dom";
import { Phone, MessageCircle } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { CONTACT } from "@/data/site";

export function MobileCTA() {
  const { t } = useLang();
  const waUrl = `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(t.contactPage.waMessage)}`;

  return (
    <div
      data-testid="mobile-sticky-cta"
      className="fixed bottom-0 left-0 right-0 z-40 lg:hidden bg-[#F9F8F3]/95 backdrop-blur-md border-t border-[#1F2421]/10 px-4 py-3 flex items-center gap-2"
    >
      <a
        href={CONTACT.phoneHref}
        data-testid="sticky-call-button"
        className="flex-1 inline-flex items-center justify-center gap-2 rounded-full border border-[#1F2421]/15 text-[#1F2421] text-[13px] font-semibold py-2.5"
      >
        <Phone size={15} /> {t.cta.call}
      </a>
      <a
        href={waUrl}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="sticky-whatsapp-button"
        className="flex-1 inline-flex items-center justify-center gap-2 rounded-full border border-[#4A5D3E]/30 text-[#4A5D3E] text-[13px] font-semibold py-2.5"
      >
        <MessageCircle size={15} /> WhatsApp
      </a>
      <Link
        to="/kontakt"
        data-testid="sticky-book-button"
        className="flex-[1.3] inline-flex items-center justify-center rounded-full bg-[#4A5D3E] text-[#F9F8F3] text-[13px] font-semibold py-2.5"
      >
        {t.cta.book}
      </Link>
    </div>
  );
}
